import axios from "axios";
export const controllerTab1 = new AbortController();
export const controllerTab2 = new AbortController();
export const getBillPayment = async (data) => {

    try {

        let res = await axios({
            method: 'post',
            signal: controllerTab1.signal,
            url: `${process.env.REACT_APP_LINEOA_V2_HOST_API}/lineoa/billpayment`,
            data: {
                "line_id": data.line_id,
                "project_id": data.project_id,
                "unit_number": data.unit_number,
                "contract_id": data.contract_id,
                "is_rem": data.is_rem,
                "is_pm": data.is_pm,
                "is_rental": data.is_rental,
                "payment_type":data.payment_type
            }
        })
        return res

    } catch (error) {
        return error
    }


}

export const getBillPaymentHistory = async (data) => {
    try {

        let res = await axios({
            method: 'post',
            signal: controllerTab2.signal,
            url: `${process.env.REACT_APP_LINEOA_V2_HOST_API}/lineoa/billpayment/history`,
            data: {
                "line_id": data.line_id,
                "project_id": data.project_id,
                "unit_number": data.unit_number,
                "contract_id": data.contract_id,
                "is_rem": data.is_rem,
                "is_pm": data.is_pm,
                "is_rental": data.is_rental
            }
        })
        return res

    } catch (error) {
        return error
    }
}

export const getBillPaymentHistoryV2 = async (data) => {
    try {

        let res = await axios({
            method: 'post',
            signal: controllerTab2.signal,
            url: `${process.env.REACT_APP_LINEOA_V2_HOST_API}/lineoa/billpaymentV2`,
            data: {
                "line_id": data.line_id,
                "project_id": data.project_id,
                "unit_number": data.unit_number,
                "contract_id": data.contract_id,
                "is_rem": data.is_rem,
                "is_pm": data.is_pm,
                "is_rental": data.is_rental
            }
        })
        return res

    } catch (error) {
        return error
    }
}

export const uploadImg = async (data, type) => {
    const formData = new FormData();
    
    // Check if data has a name property (from our modified blob) or use a default name
    const fileName = data.name || "slip_image.png";
    formData.append("data", data, fileName);
    formData.append("type", JSON.stringify(type))

    try {
        let result = await axios.post(`${process.env.REACT_APP_LINEOA_V2_HOST_API}/files`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        return result

    } catch (error) {
        return error
    }
}

export const getBillSlipPicture = async (data) => {
    try {
        let res = await axios({
            method: 'post',
            url: `${process.env.REACT_APP_LINEOA_V2_HOST_API}/billpaymentV2/get_slip`,
            data: {
               
            }
        })
        return res

    } catch (error) {
        return error
    }
}

export const uploadSlip = async (data) => {
    try {
        let res = await axios({
            method: 'post',
            signal: controllerTab2.signal,
            url: `${process.env.REACT_APP_LINEOA_V2_HOST_API}/lineoa/billpayment/uploadslip`,
            data: {
                "company_id": data.company_id,
                "line_id": data.line_id,
                "language": data.language,
                "product_type": data.product_type,
                "project_id": data.project_id,
                "items": data.items,
                "contract_id": data.contract_id,
                "file_id": data.file_id
            }
        })
        return res

    } catch (error) {
        return error
    }
}
